// @flow
import { graphql } from 'react-relay';

graphql`
	fragment articleSpellCheckStatusFields on SpellCheckStatus {
		id
		checkId
		userId
		startedAt
		response
		passed
		error
		user {
			id
			name
		}
	}
`;



// WEBPACK FOOTER //
// src/components/articles/articleSpellCheckStatusFields.js